import { memo } from "react";

type IconProps = {
  width?: number;
  height?: number;
  className?: string;
};

export const PencilIcon: React.FC<IconProps> = memo(
  ({ width = 48, height = 48, className }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6.26064 36.5332L4.94548 42.2323L10.6445 40.9171L6.26064 36.5332Z"
        fill="#3F3F3F"
      />
      <path
        d="M17.6587 37.41L9.76773 29.519L6.65917 36.9318L10.246 40.5186L17.6587 37.41Z"
        fill="#A57939"
      />
      <path
        d="M30.6193 8.6674L9.7677 29.519L17.6587 37.41L38.5103 16.5584L30.6193 8.6674Z"
        fill="#F4AA41"
      />
      <path
        d="M11.1777 30.9375L32.1777 9.93755"
        stroke="#D28210"
        strokeLinejoin="round"
      />
      <path
        d="M13.1777 33.9375L34.1777 12.9375"
        stroke="#D28210"
        strokeLinejoin="round"
      />
      <path
        d="M16.1777 35.9375L37.1777 14.9375"
        stroke="#D28210"
        strokeLinejoin="round"
      />
      <path
        d="M38.9968 16.6628L30.3917 8.05774L34.9913 3.45812L43.5964 12.0632L38.9968 16.6628Z"
        fill="#EA5A47"
      />
      <path
        d="M34.9618 3.61784L35.0399 3.55362C35.234 3.42539 35.4981 3.44695 35.6689 3.61784L43.5597 11.5086C43.7549 11.7038 43.7549 12.0204 43.5597 12.2157L19.3371 36.4382C19.2931 36.4823 19.2409 36.5182 19.1838 36.5432L5.14666 42.6903C4.95816 42.7729 4.73774 42.7315 4.59216 42.5861C4.44658 42.4405 4.4053 42.2201 4.48789 42.0316L10.6343 27.9937L10.6799 27.9122C10.6974 27.8866 10.7173 27.8624 10.7393 27.8404L34.9618 3.61784Z"
        stroke="black"
        strokeLinejoin="round"
      />
      <path
        d="M6.69901 36.9716L10.2061 40.4787M9.67962 29.4309L17.6694 37.4207M30.7587 8.28189L39.0881 16.6113"
        stroke="black"
        strokeLinejoin="round"
      />
    </svg>
  )
);
